import axios from 'axios';
import { getCompanyIdFromFWALayer, getSalesOrgMap } from '../../utils';
import { RequestHandler } from '../../app/RequestHandler';

export interface PricingItem {
  material: string;
  quantity: number;
  icode1: string;
}
export interface PricingItemResponse extends PricingItem {
  net: number;
  currency: string;
  icode2: string;
  messages: string | { item: string };
  varcond: string;
}

interface PricingRequest {
  materials: { item: PricingItem[] };
  language: string;
}

interface PricingResponse {
  GetNetPriceResponse: {
    materials: { item: PricingItemResponse[] };
  };
}

type PricingHeaders = {
  Authorization: string;
  'X-Apikey'?: string;
  'Content-Type': string;
};

export async function getPrices(items: PricingItem[], token: string, language: string): Promise<PricingItemResponse[]> {
  const { country } = new RequestHandler();
  const sID = getSalesOrgMap(country);
  const cID = getCompanyIdFromFWALayer();
  const pricingEndpoint = `${process.env.REACT_APP_FESTO_PRICING_API_ENDPOINT}/customer/${cID}/salesorg/${sID}`;
  const url = `${process.env.REACT_APP_FESTO_PRICING_API_DOMAIN || ''}${pricingEndpoint}`;

  const requestBody: PricingRequest = {
    materials: {
      item: items,
    },
    language: language.toUpperCase(),
  };

  const headers: PricingHeaders = {
    Authorization: `${process.env.REACT_APP_FESTO_PRICING_API_APIKEY_HEADER}`,
    'Content-Type': `${process.env.REACT_APP_FESTO_PRICING_API_CONTENTTYPE_HEADER}`,
  };

  const options = { headers };

  const {
    data: {
      GetNetPriceResponse: {
        materials: { item },
      },
    },
  } = await axios.post<PricingResponse>(url, JSON.stringify(requestBody), options);
  return item;
}
